module.exports = __webpack_public_path__ + "static/media/submenu-unidades.740f1aa4.svg";